<template>
  <div class="card-order" @click="onclickCard">
    <div v-if="!description" style="padding: 12px 40px 0px">
      <b-tag type="is-info">#{{ id }}</b-tag>
    </div>
    <div class="columns is-mobile" style="padding: 12px 40px 0px">
      <div v-if="description" :class="`column is-5`">
        <span class="heading">order id</span>
        <p :class="`${description ? '' : 'text-box'}`">{{ id }}</p>
      </div>
      <div v-if="!description" class="column">
        <span v-if="!description" class="heading">Origin</span>
        <p v-if="!description" class="text-box">{{ origin }}</p>
      </div>
      <div v-if="!description" class="column">
        <span v-if="!description" class="heading">Destination</span>
        <p v-if="!description" class="text-box">{{ destination }}</p>
      </div>
      <div v-if="!description" class="column">
        <span class="heading">Time</span>
        <p class>{{ time }}</p>
      </div>
      <div v-else class="column">
        <span class="heading">Status</span>
        <b-tag type=" is-dark" size="is-small">{{ status }}</b-tag>
      </div>
      <slot class="column"></slot>
    </div>
    <b-collapse
      :open="description"
      :style="`padding: ${description ? '0 40px 20px' : '0px'};`"
      position="is-bottom"
      aria-id="contentIdForA11y1"
    >
      <div class="columns is-mobile">
        <div class="column is-3">
          <span class="heading">origin</span>
          <p class>{{ origin }}</p>
        </div>
        <div class="column is-9">
          <span class="heading">destination</span>
          <p class>{{ destination }}</p>
        </div>
      </div>
      <div class="columns is-mobile">
        <div class="column is-3">
          <span class="heading">Date</span>
          <p class>{{ date }}</p>
        </div>
        <div class="column is-2">
          <span class="heading">Time</span>
          <p class>{{ time }}</p>
        </div>
        <div class="column is-5">
          <span class="heading">name</span>
          <p class>{{ name }}</p>
        </div>
        <div class="column is-2">
          <span class="heading">price</span>
          <p class>{{ price }}</p>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
// let branch = require('@/assets/logo-villa-mobile.svg')
export default {
  props: [
    "id",
    "time",
    "date",
    "name",
    "price",
    "origin",
    "destination",
    "status",
    "destinationLocation",
  ],
  data() {
    return {
      description: false,
    };
  },
  mounted() {
    // console.log(this.status);
  },
  methods: {
    onclickCard() {
      const position = {
        origin: this.origin,
        destination: this.destination,
        id: this.id,
        active: this.description,
        driver: null
      };

      if(this.destinationLocation){
        position.destination = `${this.destinationLocation.lat} ${this.destinationLocation.lng}`;
      }

      this.description = !this.description;
      this.$emit("onclick", position);
    },
  },
};
</script>

<style scoped>
.card-order {
  border: 1px solid white;
  cursor: pointer;
  color: white;
  /* border-radius: 10px; */
  /* margin: 0.5rem 0.5rem; */
  border-bottom: 1px solid #e8e8e8;
}
.card-order {
  background-color: white;
  color: #2c2a74;
}
.card-order:hover {
  background-color: #f0f0f0;
  width: 100%;
  color: #2c2a74;
}
.text-title {
  font-size: 13px;
}
.text-box {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1; /* number of lines to show */
  -webkit-box-orient: vertical;
}
.columns:not(:last-child) {
  margin-bottom: 0;
}
p {
  /* font-size: 14px; */
}
</style>